import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {OuterPagesGuardService} from '../../../guards/outer-pages-guard.service';
import {ForBusinessesComponent} from './for-businesses.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.landingForBusinesses.pageInRouting,
    data: {data: PAGES_AND_PATHS.landingForBusinesses},
    component: ForBusinessesComponent,
    canActivate: [OuterPagesGuardService],
    loadChildren: () => import('./for-businesses.module').then(m => m.ForBusinessesModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ForBusinessesRoutingModule { }
